import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  type PersistConfig,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// import reduxLogger from 'redux-logger'
import cartReducer from '../features/cart/cartSlice'
import themeReducer, {
  type ThemeState,
} from '../features/theme/themeSlice'
import { THEME_KEYS } from '../features/theme/theme.constants'
// const logger = reduxLogger.createLogger()

const themePersistConfig: PersistConfig<ThemeState> = {
  key: THEME_KEYS.sliceName,
  storage,
  whitelist: [THEME_KEYS.mode],
}

const persistedThemeReducer = persistReducer(themePersistConfig, themeReducer)

const rootReducer = combineReducers({
  cart: cartReducer,
  [THEME_KEYS.sliceName]: persistedThemeReducer,
})

const store = configureStore({
  // NOTE combines reducers for you without redux combineReducers function
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [
        FLUSH,
        REHYDRATE,
        PAUSE,
        PERSIST,
        PURGE,
        REGISTER,
      ],
    },
  }),
  // insightful, can be a little hard to read
  // middleware: getDefaultMiddleware => getDefaultMiddleware().concat(logger)
})

export const persistor = persistStore(store)
export default store

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
